import { ActionItemType } from '../../DomainEnums';
import { ActionItem, Card } from '../../@types/domain';

type NewActionItem = Pick<ActionItem, 'type' | 'text' | 'platformActionItemId'>;

export const castingWorkItems = (
  card: Card,
  value: ActionItem['text'],
  type: string,
  platformActionItemId?: ActionItem['platformActionItemId']
): NewActionItem => {
  switch (type) {
    case ActionItemType.TEXT_NOTE: {
      return { text: value, type };
    }

    default: {
      return {
        type: ActionItemType.WORK_ITEM,
        platformActionItemId,
      };
    }
  }
};
